var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingBrowseproducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 242,
    height: 59
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-992.167 -53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M997.167 53h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.167 54a4 4 0 00-4 4v49a4 4 0 004 4h32a4 4 0 004-4V58a4 4 0 00-4-4h-32m0-1h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1022.167 100)",
    fill: "#ffce2b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e9db0",
    d: "M993.167 76h40v20h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.167 62h-17a1 1 0 01-1-1 1 1 0 011-1h17a1 1 0 011 1 1 1 0 01-1 1z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.167 66h-8a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1zM998.167 101.75a1.251 1.251 0 00-1.25 1.25v2a1.251 1.251 0 001.25 1.25h8a1.251 1.251 0 001.25-1.25v-2a1.251 1.251 0 00-1.25-1.25h-8m0-.75h8a2 2 0 012 2v2a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2a2 2 0 012-2z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M997.167 53h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.167 54a4 4 0 00-4 4v49a4 4 0 004 4h32a4 4 0 004-4V58a4 4 0 00-4-4h-32m0-1h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1022.167 100)",
    fill: "#ffce2b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M993.167 76h40v20h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.167 62h-17a1 1 0 01-1-1 1 1 0 011-1h17a1 1 0 011 1 1 1 0 01-1 1z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.167 66h-8a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1zM998.167 101.75a1.251 1.251 0 00-1.25 1.25v2a1.251 1.251 0 001.25 1.25h8a1.251 1.251 0 001.25-1.25v-2a1.251 1.251 0 00-1.25-1.25h-8m0-.75h8a2 2 0 012 2v2a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2a2 2 0 012-2z",
    fill: "#6e9db0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M997.167 53h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.167 54a4 4 0 00-4 4v49a4 4 0 004 4h32a4 4 0 004-4V58a4 4 0 00-4-4h-32m0-1h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1022.167 100)",
    fill: "#ffce2b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M993.167 76h40v20h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.167 62h-17a1 1 0 01-1-1 1 1 0 011-1h17a1 1 0 011 1 1 1 0 01-1 1z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.167 66h-8a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1zM998.167 101.75a1.251 1.251 0 00-1.25 1.25v2a1.251 1.251 0 001.25 1.25h8a1.251 1.251 0 001.25-1.25v-2a1.251 1.251 0 00-1.25-1.25h-8m0-.75h8a2 2 0 012 2v2a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2a2 2 0 012-2z",
    fill: "#6e9db0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M997.167 53h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.167 54a4 4 0 00-4 4v49a4 4 0 004 4h32a4 4 0 004-4V58a4 4 0 00-4-4h-32m0-1h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1022.167 100)",
    fill: "#ffce2b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M993.167 76h40v20h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.167 62h-17a1 1 0 01-1-1 1 1 0 011-1h17a1 1 0 011 1 1 1 0 01-1 1z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.167 66h-8a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1zM998.167 101.75a1.251 1.251 0 00-1.25 1.25v2a1.251 1.251 0 001.25 1.25h8a1.251 1.251 0 001.25-1.25v-2a1.251 1.251 0 00-1.25-1.25h-8m0-.75h8a2 2 0 012 2v2a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2a2 2 0 012-2z",
    fill: "#6e9db0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M997.167 53h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.167 54a4 4 0 00-4 4v49a4 4 0 004 4h32a4 4 0 004-4V58a4 4 0 00-4-4h-32m0-1h32a5 5 0 015 5v49a5 5 0 01-5 5h-32a5 5 0 01-5-5V58a5 5 0 015-5z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1022.167 100)",
    fill: "#ffce2b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M993.167 76h40v20h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.167 62h-17a1 1 0 01-1-1 1 1 0 011-1h17a1 1 0 011 1 1 1 0 01-1 1z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.167 66h-8a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1zM998.167 101.75a1.251 1.251 0 00-1.25 1.25v2a1.251 1.251 0 001.25 1.25h8a1.251 1.251 0 001.25-1.25v-2a1.251 1.251 0 00-1.25-1.25h-8m0-.75h8a2 2 0 012 2v2a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2a2 2 0 012-2z",
    fill: "#6e9db0"
  })))));
}
export default SvgOnboardingBrowseproducts;